import WiderLink from '@prismamedia/wider-link'

const linkCards = [...document.querySelectorAll('.linkCard')]

linkCards.forEach((linkCard) => {
	const widerLinkListItem = new WiderLink(linkCard as HTMLElement)
	widerLinkListItem.init()
})
